import http from "@/http-common";

const BASE = "statistics/employee-student-attendance";

class EmployeeStudentAttendanceKpiService {
  getKpi(employeeId, date) {
    return http.get(`${BASE}/kpi`, { params: { employeeId, date } });
  }
}

export default new EmployeeStudentAttendanceKpiService();
